<ng-container *ngIf="hasContent">
  <!-- String content -->
  <ng-container *ngIf="isString(blocks) && blocks">
    <div [class]="className">{{ blocks }}</div>
  </ng-container>
  
  <!-- ContentBlock array -->
  <div *ngIf="isContentBlockArray(blocks) && blocks && blocks.length > 0" class="content-blocks" [class]="className">
    <ng-container *ngFor="let block of blocks">
      <!-- Text block -->
      <span *ngIf="block.type === 'text'" class="text-block" [class.emphasis]="block.emphasis">
        {{block.content}}<br *ngIf="block.linebreak">
      </span>
      
      <!-- Image block -->
      <span *ngIf="block.type === 'image'" class="image-block">
        <img [src]="block.url" [alt]="block.alt || ''" class="inline-image">
      </span>
    </ng-container>
  </div>
</ng-container> 